function validation(value, key, errors, func) {
    return !func(value)
        ? validationSuccess(key, errors)
        : validationError(key, errors);
}

function validationSuccess(key, errors) {
    return Object.assign({}, errors, {[key]: true});
}

function validationError(key, errors) {
    const newErrors = Object.assign({}, errors);
    delete newErrors[key];
    return newErrors;
}

export {
    validation,
    validationSuccess,
    validationError
};